module.exports = __webpack_public_path__ + "img/a7.06e03e29.png";